/**
 * Created by Jerker Nord on 2022-06-30.
 */
import {TheBorderSuperFSIntroView} from "./superfreespin/TheBorderSuperFSIntroView";
import {gsap} from "gsap";

export class TheBorderFSToSuperFSIntroView extends TheBorderSuperFSIntroView {

    constructor() {
        super();
        this.name = "TheBorderFSToSuperFSIntroView";
    }
}